module.exports = __webpack_public_path__ + "static/me-4a80b2f0aa32ec8b721747b58b573cbb.jpg";